import React, { Component } from 'react';
import Button from '../Buttons/Button/Button';
import IconButton from '../Buttons/IconButton/IconButton';
import { T, TString } from '../Response/Utils';

interface Props {
  polls: any;
  pollSubmit: Function;
  langCode: string;
}

interface State {
  pollSelected: string;
  hovered: string;
}

const styleVars = getComputedStyle(document.querySelector(':root'));

class Polls extends Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      pollSelected: '',
      hovered: ''
    };
  }

  handlePollAnsChange = poll => {
    this.setState({
      pollSelected: poll
    });
  };

  handleHovered = hov => {
    this.setState({
      hovered: hov
    });
  };

  render() {
    return (
      <div
        tabIndex={0}
        className="sf-each-offer"
        style={{ wordBreak: 'break-word' }}
      >
        {/* closing/deleting polls not possible yet */}
        {/* <IconButton
                  variant={'filled'}
                  size={'small'}
                  className="clickable card-close"
                  onClick={this.props.pollSubmit.bind(
                    this,
                    this.props.polls.polls_id,
                    this.props.polls.userId,
                    ''
                  )}
                  title={'Dismiss'}
                  image={'close'}
                /> */}
        <div className="each-offer-card-title">
          {this.props.polls.polls_title}
        </div>
        <div className="each-offer-card-msg">
          {this.props.polls.poll_question}
        </div>

        <div className="each-offer-card-content" style={{ marginTop: '24px' }}>
          {this.props.polls.pollsResponseDtos.map((opt, index) => {
            return (
              <div
                key={index}
                className="polls-options"
                onMouseOver={() => this.handleHovered(opt.polls_option_id)}
                onMouseOut={() => this.handleHovered('')}
                onClick={() =>
                  this.handlePollAnsChange(opt.polls_option_id.toString())
                }
              >
                <div className={`radio-icon-div `}>
                  {opt.polls_option_id.toString() ===
                  this.state.pollSelected ? (
                    <IconButton
                      variant={'empty'}
                      size="large"
                      ariaLabelledBy={opt.polls_option.replace(/\s/g, '_')}
                      fill={styleVars.getPropertyValue('--srvMsgColor')}
                      title={TString({
                        labelName: 'SelectedLabel',
                        langCode: this.props.langCode,
                        fromClass: true
                      })}
                      image={'checkedRadio'}
                      hovered={opt.polls_option_id === this.state.hovered}
                      fullColor
                    />
                  ) : (
                    <IconButton
                      variant={'empty'}
                      size="large"
                      ariaLabelledBy={opt.polls_option.replace(/\s/g, '_')}
                      image={'uncheckedRadio'}
                      title={TString({
                        labelName: 'unselectedLabel',
                        langCode: this.props.langCode,
                        fromClass: true
                      })}
                      fill={styleVars.getPropertyValue('--srvMsgColor')}
                      hovered={opt.polls_option_id === this.state.hovered}
                    />
                  )}
                </div>
                <span>{opt.polls_option}</span>
                <span id={opt.polls_option.replace(/\s/g, '_')} hidden>
                  {`${
                    opt.polls_option_id.toString() === this.state.pollSelected
                      ? TString({
                          labelName: 'SelectedLabel',
                          langCode: this.props.langCode,
                          fromClass: true
                        })
                      : TString({
                          labelName: 'unselectedLabel',
                          langCode: this.props.langCode,
                          fromClass: true
                        })
                  } ${opt.polls_option}`}
                </span>
              </div>
            );
          })}
        </div>
        <Button
          title={
            this.state.pollSelected === ''
              ? TString({
                  labelName: 'disabledLabel',
                  langCode: this.props.langCode,
                  fromClass: true
                })
              : TString({
                  labelName: 'enabledLabel',
                  langCode: this.props.langCode,
                  fromClass: true
                })
          }
          className="each-offer-card-submit"
          onClick={this.props.pollSubmit.bind(
            this,
            this.props.polls.polls_id,
            this.props.polls.userId,
            this.state.pollSelected
          )}
          fullWidth
          disabled={this.state.pollSelected === ''}
        >
          <T labelName="submitLabel" />
        </Button>
      </div>
    );
  }
}

export default Polls;
